module.exports = __webpack_public_path__ + "static/media/analysis.0e718e1a.svg";